import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { InviteUserForm } from './InviteUserForm';

export class ManageUsers extends Component {
    static displayName = ManageUsers.name;

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            loading: true,
            inviteUserDialogOpen: false,
        };
    }

    componentDidMount() {
        this.populateUsers();
    }

    async populateUsers() {
        const response = await fetch('/api/user/get-users');
        const data = await response.json();
        this.setState({ users: data, loading: false });
    };

    handleInviteUserClicked = () => {
        this.setState({ inviteUserDialogOpen: true });
    };

    handleInviteUserDialogClose = () => {
        this.setState({ inviteUserDialogOpen: false });
    };

    handleInviteUserSent = () => {
        this.inviteUserSent();
    };

    async inviteUserSent() {
        //refresh LIST???


        //console.log("CALL API");
        //const researcherId = this.state.researcherId ? this.state.researcherId : 0;
        //const params = new URLSearchParams({ search: this.state.search, researcherId: researcherId });
        //const response = await fetch('api/contacts/get-contacts?' + params);
        //const data = await response.json();

        //this.setState({ contacts: data });
    };

    removeAdminRole = (userId) => {
        fetch('/api/user/remove-role', {
            method: "POST",
            body: JSON.stringify({ userId: userId, role: "Admin" }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateUsers();
                }
            })
        });
    };

    removeMemberRole = (userId) => {
        fetch('/api/user/remove-role', {
            method: "POST",
            body: JSON.stringify({ userId: userId, role: "Member" }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateUsers();
                }
            })
        });
    };

    addAdminRole = (userId) => {
        fetch('/api/user/add-role', {
            method: "POST",
            body: JSON.stringify({ userId: userId, role: "Admin" }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateUsers();
                }
            })
        });
    };

    addMemberRole = (userId) => {
        fetch('/api/user/add-role', {
            method: "POST",
            body: JSON.stringify({ userId: userId, role: "Member" }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateUsers();
                }
            })
        });
    };

    renderUsersTable(users) {
        return (
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user =>
                        <tr key={user.userId}>
                            <td>{user.email}</td>
                            <td>{user.role}</td>
                            <td>
                                {
                                    user.role === "Admin" ?
                                        <button onClick={() => this.removeAdminRole(user.userId)} className="btn btn-sm btn-outline-danger">Remove Admin</button> :
                                        user.role === "Member" ?
                                            <div><Button onClick={() => this.addAdminRole(user.userId)} class="btn btn-sm btn-outline-success">Grant Admin</Button> <Button onClick={() => this.removeMemberRole(user.userId)} class="btn btn-sm btn-outline-danger">Remove Membership</Button></div> :
                                                <Button onClick={() => this.addMemberRole(user.userId)} class="btn btn-sm btn-outline-success">Grant Membership</Button>
                                        
                                }
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUsersTable(this.state.users);

        return (
            <div>
                <h1>User Management</h1>
                <hr />
                <div class="card mt-4 mb-5">
                    <h2 class="card-header">Members<Button onClick={this.handleInviteUserClicked} class="btn btn-primary float-right">Invite a New User</Button></h2>
                    <div class="card-body">
                        {contents}
                    </div>
                </div>

                
                <Dialog disableBackdropClick open={this.state.inviteUserDialogOpen} onClose={this.handleInviteUserDialogClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Invite New User</DialogTitle>
                    <DialogContent>
                        <InviteUserForm onSubmit={this.handleInviteUserSent} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleInviteUserDialogClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
